
export class BillingInfo {
    id: string = null;
    organizationId: string = null;
    isPrimary: boolean = null;
    createdAt: any = null;
    customerVaultId: string = null;
    billingId: string = null;
    type: string = null;
    firstName: string = null;
    lastName: string = null;
    company: string = null;
    address: string = null;
    city: string = null;
    state: string = null;
    zip: string = null;
    country: string = null;
    phone: string | undefined;
    email: string = null;
    paymentMethodId: string = null;
    gatewayCustomerId: string = null;

    card: CardData | undefined;
    check: CheckData | undefined;

    constructor(x: Partial<BillingInfo>) {
        const skipKeys = ['paymentMethodId', 'gatewayCustomerId', 'card', 'check'];
        Object.keys(this).forEach(key => {
            if (skipKeys.includes(key)) {
                return;
            }
            if (x[key] == null)
                throw new Error(`${key} cannot be null.`);
        });

        Object.assign(this, x);
    }
}

export class CardData {
    bin: string = null;
    exp: string = null;
    number: string = null;
    type: string = null;
}

export class CheckData {
    aba: string = null;
    account: string = null;
    name: string = null;
}
